import React, {useEffect, useRef, useState, forwardRef} from "react";
import {motion, useScroll, useTransform} from "framer-motion";
import "./Timeline.css"; // ✅ Make sure this is imported
import SectionHeading3 from "../../SectionHeadings/Heading3/SectionHeading3";

export const Timeline = forwardRef(({data}, ref) => {
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const [trackHeight, setTrackHeight] = useState(0);

  const {scrollYProgress} = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, trackHeight]
  );
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  useEffect(() => {
    if (trackRef.current) {
      setTrackHeight(trackRef.current.getBoundingClientRect().height);
    }
  }, [data]);

  return (
    <div className="timeline-container" ref={containerRef}>
      <SectionHeading3
        title="Changelog from my journey"
        description="I've been working on Aceternity for the past 9+ years. Here's
          a timeline of my journey."
      />

      <div ref={trackRef} className="timeline-track-wrapper">
        {data.map((item, index) => (
          <div key={index} className="timeline-entry">
            <div className="timeline-sticky">
              <div className="timeline-icon">
                <div className="timeline-dot" />
              </div>
              <h3 className="timeline-title-desktop">{item.title}</h3>
            </div>

            <div className="timeline-content">
              <h3 className="timeline-title-mobile">{item.title}</h3>
              {item.content}
            </div>
          </div>
        ))}

        <div
          style={{height: `${trackHeight}px`}}
          className="timeline-track-line"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="timeline-track-progress"
          />
        </div>
      </div>
    </div>
  );
});

Timeline.displayName = "Timeline";
